import { PUBLIC_AUTHORIZATION, TOKEN_URL } from "@/utils/apiUrls";
import { createReferenceId } from "@/utils/initializeSentry";

/**
 * OAuth client-credentials token for the public API user (magic link, agent login, etc.).
 */
export const fetchPublicAccessToken = async (): Promise<string> => {
  const response = await fetch(
    `${TOKEN_URL.toString()}?grant_type=client_credentials&scope=all`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: PUBLIC_AUTHORIZATION,
        "X-Reference-Id": createReferenceId(),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Public token request failed: ${response.status}`);
  }

  const data = await response.json();

  if (!data.access_token) {
    throw new Error("Public token response missing access_token");
  }

  return data.access_token;
};
